/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
// import "../../src/assets/js/app";
// import { baricon1, imguser, logo, noteicon, noteicon1, searchnormal, settingicon01, user06 } from './imagepath';
import {
  baricon,
  baricon1,
  searchnormal,
  imguser,
  user06,
  settingicon01,
} from "../imagepath";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHomePath } from "../../lib/homePath";
import { message } from "antd";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const roleLabel = user?.is_admin
    ? 'Administrador'
    : (user?.profile?.name || 'Usuario');

  const handleLogout = async () => {
    try {
      await logout();
      message.success('Sesión cerrada correctamente');
      navigate('/login', { replace: true });
    } catch (error) {
      console.error('Logout error:', error);
      message.error('Error al cerrar sesión');
    }
  };

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
    document.getElementsByTagName("html")[0].classList.toggle('menu-opened');
    document.getElementsByClassName("sidebar-overlay")[0].classList.toggle("opened");
  };

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        }
      }
    };

    const maximizeBtn = document.querySelector(".win-maximize");
    // maximizeBtn.addEventListener('click', handleClick);

    return () => {
      // maximizeBtn.removeEventListener('click', handleClick);
    };
  }, []);
  return (
    <div className="main-wrapper">
      <div className="header">
        <div className="header-left">
          <Link to={defaultHomePath(user)} className="logo">
            <img src="/eCliniQ.png" width={32} height={32} alt="eCliniq" style={{ borderRadius: '7px' }} />
            <span>eCliniq</span>
          </Link>
        </div>
        <Link id="toggle_btn" to="#" onClick={handlesidebar}>
          <img src={baricon} alt="" />
        </Link>
        <Link id="mobile_btn" className="mobile_btn float-start" to="#" onClick={handlesidebarmobilemenu}>
          <img src={baricon1} alt="" />
        </Link>
        <div className="top-nav-search mob-view">
          <form>
            <input
              type="text"
              className="form-control"
              placeholder="Buscar..."
            />
            <Link className="btn">
              <img src={searchnormal} alt="" />
            </Link>
          </form>
        </div>
        <ul className="nav user-menu float-end">
          <li className="nav-item dropdown has-arrow user-profile-list">
            <Link
              to="#"
              className="dropdown-toggle nav-link user-link"
              data-bs-toggle="dropdown"
            >
              <div className="user-names">
                <h5>{user?.name || 'Usuario'}</h5>
                <span>{roleLabel}</span>
              </div>
              <span className="user-img">
                <img src={user06} alt={roleLabel} />
              </span>
            </Link>
            <div className="dropdown-menu">
              <Link className="dropdown-item" to="/profile">
                Mi Perfil
              </Link>
              <Link className="dropdown-item" to="/edit-profile">
                Editar Perfil
              </Link>
              <Link className="dropdown-item" to="/settings">
                Configuración
              </Link>
              <button className="dropdown-item" onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left' }}>
                Cerrar Sesión
              </button>
            </div>
          </li>
          <li className="nav-item ">
            <Link to="/settings" className="hasnotifications nav-link">
              <img src={settingicon01} alt="" />{" "}
            </Link>
          </li>
        </ul>
        <div className="dropdown mobile-user-menu float-end">
          <Link
            to="#"
            className="dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-ellipsis-vertical" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end">
            <Link className="dropdown-item" to="/profile">
              Mi Perfil
            </Link>
            <Link className="dropdown-item" to="/edit-profile">
              Editar Perfil
            </Link>
            <Link className="dropdown-item" to="/settings">
              Configuración
            </Link>
            <button className="dropdown-item" onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left' }}>
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
